import PageInterface from "@app/Interface/PageInterface";
import GeneralPageAcfInterface from "@app/Interface/GeneralPageAcfInterface";

export default class PageModel implements PageInterface {

    public id: number;
    public title: string;
    public slug: string;
    public link: string;
    public path: string;
    public template: string;
    public subfields: string;
    public acf: GeneralPageAcfInterface;
    public content: string;

    constructor() {

        this.id = 0;
        this.title = "";
        this.slug = "";
        this.link = "";
        this.path = "";
        this.template = "";
        this.subfields = "";
        this.acf = JSON.parse("{}");
        this.content = "";

    }
}